import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {
  constructor(
  ) {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/disclaimer/disclaimer.component.ts